import React from "react";

const Footer = () => {
  return (
    <footer className="bg-zinc-800 text-white p-4 flex flex-col md:flex-row items-center justify-between">
      {/* LEFT */}
      <aside className="mb-4 md:mb-0 text-center md:text-left">
        <p className="text-base">
          Copyright <span className="font-extrabold">Md. Tayyab</span> ©{" "}
          {new Date().getFullYear()} — All rights reserved
        </p>
      </aside>

      {/* SOCIAL ICONS */}
      <nav className="flex gap-6">
        {/* GitHub */}
        <a
          href="https://github.com/tayyab011"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-lime-400 transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M12 0a12 12 0 0 0-3.8 23.4c.6.1.8-.2.8-.5v-2c-3.3.7-4-1.5-4-1.5a3.2 3.2 0 0 0-1.4-1.8c-1.1-.8.1-.8.1-.8a2.5 2.5 0 0 1 1.9 1.3 2.6 2.6 0 0 0 3.5 1 2.6 2.6 0 0 1 .8-1.6c-2.7-.3-5.5-1.3-5.5-5.7a4.5 4.5 0 0 1 1.2-3.2 4.2 4.2 0 0 1 .1-3.1s1-.3 3.3 1.2a11.3 11.3 0 0 1 6 0C17 6.2 18 6.5 18 6.5a4.2 4.2 0 0 1 .1 3.1 4.5 4.5 0 0 1 1.2 3.2c0 4.4-2.8 5.4-5.5 5.7a2.8 2.8 0 0 1 .8 2.2v3.3c0 .3.2.6.8.5A12 12 0 0 0 12 0z" />
          </svg>
        </a>

        {/* Facebook */}
        <a
          href="https://www.facebook.com/tayyab2627"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-lime-400 transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
          </svg>
        </a>

        {/* LinkedIn */}
        <a
          href="https://www.linkedin.com/in/md-tayyab3/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-lime-400 transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M4.98 3.5c0 1.38-1.11 2.5-2.48 2.5S0 4.88 0 3.5 1.11 1 2.5 1s2.48 1.12 2.48 2.5zM.22 8h4.56v16H.22V8zM8.98 8h4.37v2.18h.06c.61-1.16 2.11-2.38 4.35-2.38 4.66 0 5.52 3.07 5.52 7.06V24h-4.56v-7.98c0-1.9-.03-4.34-2.64-4.34-2.64 0-3.04 2.06-3.04 4.2V24H8.98V8z" />
          </svg>
        </a>
      </nav>
    </footer>
  );
};

export default Footer;
